import { CommonActions, DrawerActions, StackActions } from '@react-navigation/native';
import 'react-native-gesture-handler';
import Funcs from '../helpers/Funcs';
import FirebaseService from './FirebaseService';

let navigator;

function setNavigator(navigatorRef) {
  Funcs.log('Navigation update navigator');
  navigator = navigatorRef;
}

function toggleDrawer() {
  navigator.dispatch(DrawerActions.toggleDrawer());
}

function closeDrawer() {
  navigator.dispatch(DrawerActions.closeDrawer());
}

function openDrawer() {
  navigator.dispatch(DrawerActions.openDrawer());
}

function navigate(name, params) {
  Funcs.log('Navigation Navigate', name, params);
  if (!name) return;

  FirebaseService.logScreen(name);
  navigator.navigate({ name, params });
}

function push(name, params) {
  Funcs.log('Navigation Push', name, params);
  if (!name) return;

  FirebaseService.logScreen(name);
  navigator.dispatch(StackActions.push(name, params));
}

function replace(name, params) {
  Funcs.log('Navigation Replace', name, params);
  if (!name) return;

  FirebaseService.logScreen(name);
  navigator.dispatch(StackActions.replace(name, params));
}

function pop(n) {
  navigator.dispatch(StackActions.pop(n));
}

function popToTop() {
  navigator.dispatch(StackActions.popToTop());
}

function reset(name, params) {
  if (!name) return;

  FirebaseService.logScreen(name);
  navigator.dispatch(CommonActions.reset({ index: 0, routes: [{ name, params }] }));
}

function back() {
  navigator.dispatch(CommonActions.goBack());
}

function getParams() {
  const currentRouter = getCurrentRouter();
  if (currentRouter?.state?.routes?.length > 0 && currentRouter?.state?.index >= 0) {
    return currentRouter?.state?.routes[currentRouter?.state?.index].params;
  }
  if (currentRouter) return currentRouter.params;
  return {};
}

function getCurrentRouter() {
  // Hàm này sẽ thay đổi từng project tùy theo cấu trúc navigator
  try {
    const rootState = navigator?.getRootState() || {};
    const { index, routes } = rootState;
    if (routes?.length > index) {
      return routes[index];
    }
  } catch (err) {
    Funcs.log(err);
  }
  return null;
}

export default {
  navigate,
  reset,
  toggleDrawer,
  closeDrawer,
  openDrawer,
  setNavigator,
  back,
  push,
  pop,
  replace,
  popToTop,
  getParams,
  getCurrentRouter
};
